import { $http } from '@/utils';
import { MD5 } from 'crypto-js';

/**
 * @namespace Service
 * @class Event
 * @exports Service/Cms/Event
 * @description API Event Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Event {
	/**
	 * @static @name list
	 * @description Get all events as a list that can be manipulated through post body properties
	 * @returns {Object} Promise a http response
	 */
	static list(payload, domain, cache = true) {
		const cacheHash = MD5(JSON.stringify({ payload, domain })).toString();
		return $http.post(
			'cms/event/list',
			{ ...payload, cacheHash },
			{
				cache,
				cachePath: `table-cms-event-${cacheHash}`
			}
		);
	}

	/**
	 * @static @name get
	 * @description Get event using id
	 * @param {String} id
	 * @returns {Object} Promise a http response
	 */
	static get(id, domain, cache = true) {
		const cacheHash = MD5(JSON.stringify({ payload: { id }, domain })).toString();
		return $http.get(`cms/event/${id}?cacheHash=${cacheHash}`, {
			cache,
			cachePath: `table-cms-event-${cacheHash}`
		});
	}
}
